import React, { useState, useEffect } from "react";
import forgotPwdImage from "../../assets/Forgot Password 1 Orange.png";
import { MdOutlineMail } from "react-icons/md";
import { BsArrowUpRightCircle } from "react-icons/bs";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { FiUser } from "react-icons/fi";
import LoginSubmitWhiteIcon from "../../assets/Icons/RegisterLoginIconOrange.png";
import CircularProgress from "@mui/material/CircularProgress";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import { useNavigate } from "react-router-dom";
import "../../css/Login.css";
import encryptAES from "../../helpers/encryption";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [formStage, setFormStage] = useState("username"); // 'username', 'otp', 'password'
  const [captcha, setCaptcha] = useState("");
  const [loading, setLoading] = useState(false);
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const [usernameError, setUsernameError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const generateCaptcha = () => {
    return Math.floor(100000 + Math.random() * 900000).toString();
  };

  const reloadCaptcha = () => {
    setCaptcha(generateCaptcha());
    setCaptchaError("");
  };

  useEffect(() => {
    reloadCaptcha();
  }, []);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  // Submit Username and Captcha for OTP generation
  const handleSubmit = (event) => {
    event.preventDefault();

    const usernameValid = username ? "" : "Username is required";
    const captchaValid =
      captcha === captchaInput ? "" : "Incorrect CAPTCHA, please try again.";

    setUsernameError(usernameValid);
    setCaptchaError(captchaValid);

    if (usernameValid || captchaValid) {
      return;
    }

    setLoading(true);
    const encryptedUsername = encryptAES(username);
    const data = { username: encryptedUsername };

    axiosPostApi(apiList.FORGOTPWD, data)
      .then((response) => {
        const respCode = response?.data?.respCode;
        const message =
          response?.data?.message ||
          "OTP successfully sent on your registered mobile number";

        if (response?.status === 200 && respCode === "00") {
          CustomAlert({
            title: "OTP sent successfully",
            text: message,
            icon: "success",
            confirmButtonText: "Ok",
          });
          setFormStage("otp");
        } else {
          CustomAlert({
            title: "Failed...Check the Username!",
            text: message,
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      })
      .catch((error) => {
        console.error("API Error:", error.response || error.message);
        CustomAlert({
          title: "Error",
          text: "An error occurred while fetching the data. Please try again later.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Submit OTP for validation
  const handleOtpSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    const encryptedUsername = encryptAES(username);

    const data = { username: encryptedUsername, otp };

    axiosPostApi(apiList.VALIDATE_OTP, data)
      .then((response) => {
        const respCode = response?.data?.respCode;
        const message = response?.data?.message || "OTP validated successfully";

        if (response?.status === 200 && respCode === "00") {
          CustomAlert({
            title: "OTP Verified !!!",
            text: message,
            icon: "success",
            confirmButtonText: "Continue",
          });
          setFormStage("password");
        } else {
          CustomAlert({
            title: "Invalid OTP",
            text: message,
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      })
      .catch((error) => {
        console.error("API Error:", error.response || error.message);
        CustomAlert({
          title: "Error",
          text: "An error occurred while validating the OTP. Please try again later.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Submit New Password
  const handlePasswordSubmit = (event) => {
    event.preventDefault();

    if (newPassword !== confirmPassword) {
      CustomAlert({
        title: "Password Mismatch",
        text: "New Password and Confirm Password do not match.",
        icon: "error",
        confirmButtonText: "Retry",
      });
      return;
    }

    setLoading(true);
    const encryptedUsername = encryptAES(username);
    const encryptedPassword = encryptAES(newPassword);
    const encryptedConfirmPassword = encryptAES(confirmPassword);

    const data = {
      username: encryptedUsername,
      otp,
      password: encryptedPassword,
      confirmPassword: encryptedConfirmPassword,
    };

    axiosPostApi(apiList.UPDATE_PASSWORD, data)
      .then((response) => {
        const message =
          response?.data?.message || "Password updated successfully";

        if (response?.data?.data === null) {
          CustomAlert({
            title: "Success",
            text: message,
            icon: "success",
            confirmButtonText: "Login",
          }).then(() => {
            navigate("/");
          });
        } else {
          CustomAlert({
            title: "Failed",
            text: message,
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      })
      .catch((error) => {
        console.error("API Error:", error.response || error.message);
        CustomAlert({
          title: "Error",
          text: "An error occurred while updating the password. Please try again later.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="container-fluid">
      <div className="row align-items-center login-container">
        {/* Form Section */}
        <div className="login-form-parent col-md-6 d-flex flex-column justify-content-center">
          <p>
            Access Your Account{" "}
            <span style={{ fontWeight: "400" }}>to Get Started</span>
          </p>
          <form
            onSubmit={
              formStage === "otp"
                ? handleOtpSubmit
                : formStage === "password"
                ? handlePasswordSubmit
                : handleSubmit
            }
          >
            {formStage === "username" && (
              <>
                {/* Username input */}
                <div className="login-form-main-division form-floating mb-3">
                  <input
                    type="text"
                    className="form-control login-inputs"
                    id="floatingInput"
                    placeholder="Username"
                    value={username}
                    onChange={(event) => setUsername(event.target.value)}
                  />
                  <label
                    htmlFor="floatingInput"
                    className="flex items-center !pl-2 gap-2"
                  >
                    <FiUser /> Username
                  </label>
                  {usernameError && (
                    <p className="text-danger mt-2">{usernameError}</p>
                  )}
                </div>

                {/* CAPTCHA */}
                <div className="captcha-container mb-3">
                  <div className="captcha-box">
                    <span>{captcha}</span>
                  </div>
                  <button
                    type="button"
                    className="reload-captcha"
                    onClick={reloadCaptcha}
                  >
                    Reload Captcha
                  </button>
                </div>

                <div className="form-floating mb-3">
                  <input
                    type="text"
                    className="form-control login-inputs"
                    placeholder="Enter Captcha Value"
                    value={captchaInput}
                    onChange={(event) => setCaptchaInput(event.target.value)}
                  />
                  <label htmlFor="floatingInput">Enter CAPTCHA</label>
                  {captchaError && (
                    <p className="text-danger mt-2">{captchaError}</p>
                  )}
                </div>
              </>
            )}

            {formStage === "otp" && (
              <div className="form-floating mb-3">
                <input
                  type="text"
                  className="form-control login-inputs"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(event) => setOtp(event.target.value)}
                />
                <label>Enter OTP</label>
              </div>
            )}

            {formStage === "password" && (
              <>
                <div className="login-form-main-division form-floating">
                  <div
                    className="form-floating mb-3"
                    style={{ position: "relative" }}
                  >
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control login-inputs"
                      placeholder="New Password"
                      id="newPassword"
                      value={newPassword}
                      onChange={(event) => setNewPassword(event.target.value)}
                    />
                    <label htmlFor="newPassword">New Password</label>
                    <span onClick={toggleShowPassword} className="showpwd-eye">
                      {showPassword ? (
                        <AiOutlineEyeInvisible />
                      ) : (
                        <AiOutlineEye />
                      )}
                    </span>
                  </div>

                  <div className="form-floating mb-3">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control login-inputs"
                      placeholder="Confirm Password"
                      value={confirmPassword}
                      onChange={(event) =>
                        setConfirmPassword(event.target.value)
                      }
                    />
                    <label>Confirm Password</label>
                    <span onClick={toggleShowPassword} className="showpwd-eye">
                      {showPassword ? (
                        <AiOutlineEyeInvisible />
                      ) : (
                        <AiOutlineEye />
                      )}
                    </span>
                  </div>
                </div>
              </>
            )}

            <div className="login-btn-container">
              <button type="submit" className="btn loginNow-btn">
                {loading ? (
                  <CircularProgress
                    className="circular-loader"
                    style={{ width: "20px", height: "20px" }}
                  />
                ) : (
                  <span className="login-text">
                    {formStage === "password" ? "Submit" : "Next"}
                  </span>
                )}
              </button>
              <span className="login-icon">
                <img
                  src={LoginSubmitWhiteIcon}
                  alt="SubmitIcon"
                  className="h-[50px]"
                />
              </span>
            </div>
          </form>
        </div>

        {/* Image Section */}
        <div className="col-md-6 d-none d-md-block login-image">
          <img
            className="img-fluid"
            src={forgotPwdImage}
            alt="Forgot Password"
          />
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
